module.exports = __webpack_public_path__ + "../resources/images/SkyCode_33-b0affa62f94641f4803352922b53b73e.svg";